import { createContext, useContext, useEffect, useState } from "react"; // استيراد الأدوات من React لإنشاء وإدارة الـ Context والحالة
import axios from "axios"; // استيراد axios لعمل طلبات HTTP

// إنشاء الـ Context الخاص بالمصادقة (Auth)
export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [loading, setLoading] = useState(false);       // حالة التحميل أثناء العمليات (تسجيل دخول، تسجيل خروج، تسجيل جديد)
  const [error, setError] = useState(null);            // حالة لتخزين رسالة الخطأ
  const [success, setSuccess] = useState(null);        // حالة لتخزين رسالة النجاح
  const [isLoggedIn, setIsLoggedIn] = useState(false); // حالة لمعرفة إذا المستخدم مسجل دخول أم لا
  const [userData, setUserData] = useState(null);      // تخزين بيانات المستخدم بعد تسجيل الدخول

  // عند تحميل التطبيق لأول مرة (تنفيذ هذا فقط مرة واحدة)
  useEffect(() => {
    const token = localStorage.getItem("userToken");  // جلب التوكن من التخزين المحلي (localStorage)
    if (token) {
      setIsLoggedIn(true); // إذا التوكن موجود، اعتبر المستخدم مسجل دخول

      // جلب بيانات المستخدم من localStorage وتحويلها من نص JSON لكائن JS
      const storedUser = localStorage.getItem("userData");
      if (storedUser) {
        setUserData(JSON.parse(storedUser)); // حفظ بيانات المستخدم في الحالة
      }
    }
  }, []);

  // دالة تسجيل المستخدم (Register)
  const registerUser = async (userData) => {
    setLoading(true);   // بدء حالة التحميل
    setError(null);     // مسح أي خطأ سابق
    setSuccess(null);   // مسح أي رسالة نجاح سابقة

    try {
      // إرسال طلب POST لواجهة التسجيل مع بيانات المستخدم
      const response = await axios.post(
        "https://www.quickpickdeal.com/api/auth/registration",
        userData,
        { headers: { "Content-Type": "application/json" } }
      );

      const data = response.data; // استخراج البيانات من الرد

      if (data.Success) {         // إذا التسجيل ناجح
        setSuccess("تم التسجيل بنجاح"); // حفظ رسالة النجاح
        return data;              // إعادة البيانات
      } else {                    // إذا فشل التسجيل
        setError(data.Error || "فشل في التسجيل"); // حفظ رسالة الخطأ
        return null;
      }
    } catch (err) {
      setError("تعذر الاتصال بالسيرفر"); // في حالة حدوث خطأ في الشبكة أو السيرفر
      return null;
    } finally {
      setLoading(false); // إيقاف حالة التحميل في النهاية مهما كانت النتيجة
    }
  };

  // دالة تسجيل الدخول (Login)
  const loginUser = async (credentials) => {
    setLoading(true);   // بدء حالة التحميل
    setError(null);     // مسح أي خطأ سابق
    setSuccess(null);   // مسح أي رسالة نجاح سابقة

    try {
      // إرسال طلب POST لواجهة تسجيل الدخول مع بيانات الدخول (البريد وكلمة المرور)
      const response = await axios.post(
        "https://www.quickpickdeal.com/api/auth/login",
        credentials,
        { headers: { "Content-Type": "application/json" } }
      );

      const data = response.data; // استخراج البيانات من الرد

      if (data.Success) {         // إذا تسجيل الدخول ناجح
        setSuccess("تم تسجيل الدخول بنجاح");  // حفظ رسالة النجاح
        setUserData(data.Data);                 // حفظ بيانات المستخدم في الحالة

        // حفظ التوكن وبيانات المستخدم في التخزين المحلي لاستخدامها بعد التحديث أو إعادة تحميل الصفحة
        localStorage.setItem("userToken", data.Data.AccessToken);
        localStorage.setItem("userData", JSON.stringify(data.Data));

        setIsLoggedIn(true);       // تعيين الحالة كمستخدم مسجل دخول
        return data;               // إعادة البيانات
      } else {                    // إذا فشل تسجيل الدخول
        setError(data.Error || "فشل في تسجيل الدخول"); // حفظ رسالة الخطأ
        return null;
      }
    } catch (err) {
      setError("تعذر الاتصال بالسيرفر"); // في حالة حدوث خطأ في الاتصال
      return null;
    } finally {
      setLoading(false); // إيقاف حالة التحميل
    }
  };

  // دالة تسجيل الخروج (Logout)
  const logout = () => {
    localStorage.removeItem("userToken");  // حذف التوكن من التخزين المحلي
    localStorage.removeItem("userData");   // حذف بيانات المستخدم من التخزين المحلي
    setIsLoggedIn(false);                   // تغيير حالة تسجيل الدخول إلى false
    setUserData(null);                      // مسح بيانات المستخدم من الحالة
  };

  // مزود الـ Context الذي يمرر جميع القيم والدوال للمكونات التي تستخدمه
  return (
    <AuthContext.Provider
      value={{
        registerUser,    // دالة التسجيل
        loginUser,       // دالة تسجيل الدخول
        logout,          // دالة تسجيل الخروج
        loading,         // حالة التحميل
        error,           // رسالة الخطأ
        success,         // رسالة النجاح
        isLoggedIn,      // هل المستخدم مسجل دخول
        userData,        // بيانات المستخدم
      }}
    >
      {children}  {/* عرض كل المكونات الفرعية ضمن المزود */}
    </AuthContext.Provider>
  );
}

// هوك لتسهيل استخدام الـ Context في أي مكون
export const useAuth = () => useContext(AuthContext);
